var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"inlineblock width100 yellowfont minfont"},[_c('span',[_vm._v(_vm._s(_vm.fieldName)+"：")]),_c('span',[_c('a',{staticStyle:{"color":"#ff0000"},on:{"click":function($event){return _vm.viewImg(_vm.attachmentUrl)}}},[_vm._v("查看")])])]),_c('preview-modal',{ref:"imageModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }